module.exports = __webpack_public_path__ + "static/media/mongo.6647de20.svg";